module.exports = __webpack_public_path__ + "static/media/grayCross.11cb78ef.png";